// extracted by mini-css-extract-plugin
export default {"detailUser":"detail_detailUser__hAdt1","header":"detail_header__YfxVA","content":"detail_content__7Ry+T","titlePage":"detail_titlePage__NNpjE","delete":"detail_delete__gs36z"};